/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReorderSuccessStoriesDto } from '../../models/reorder-success-stories-dto';
import { SuccessStoryResponseAdminDto } from '../../models/success-story-response-admin-dto';

export interface AdminSuccessStoriesControllerReorderSuccessStoriesV1$Params {
      body: ReorderSuccessStoriesDto
}

export function adminSuccessStoriesControllerReorderSuccessStoriesV1(http: HttpClient, rootUrl: string, params: AdminSuccessStoriesControllerReorderSuccessStoriesV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SuccessStoryResponseAdminDto>>> {
  const rb = new RequestBuilder(rootUrl, adminSuccessStoriesControllerReorderSuccessStoriesV1.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SuccessStoryResponseAdminDto>>;
    })
  );
}

adminSuccessStoriesControllerReorderSuccessStoriesV1.PATH = '/v1/admin/success-stories/reorder';
